export default "__VITE_ASSET__BotErOYI__"